var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.30576 6.94938C8.38863 6.83916 8.5451 6.81686 8.65546 6.89954L12.9721 10.1332C13.0827 10.216 13.1051 10.3729 13.0221 10.4834L9.00573 15.8333C8.03907 17.1249 6.58073 17.3833 5.5724 17.3833C4.9474 17.3833 4.4974 17.2833 4.4474 17.2749C4.33907 17.2499 4.23907 17.1749 4.18073 17.0749C4.1224 16.9666 2.68907 14.4166 4.28907 12.2916L8.30576 6.94938Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6302 8.3417L14.0718 9.08397C13.9889 9.19416 13.8325 9.21644 13.7222 9.13378L9.40482 5.89958C9.29449 5.81693 9.27188 5.66057 9.35428 5.55006L9.91351 4.80003C10.4885 4.02503 11.3802 3.6167 12.2802 3.6167C12.8968 3.6167 13.5135 3.80837 14.0468 4.20837C14.6718 4.68337 15.0802 5.37503 15.1968 6.15003C15.3052 6.93337 15.1052 7.70837 14.6302 8.3417Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8405 16.123H11.5264C11.1814 16.123 10.9014 16.403 10.9014 16.748C10.9014 17.093 11.1814 17.373 11.5264 17.373H16.8405C17.1855 17.373 17.4655 17.093 17.4655 16.748C17.4655 16.403 17.1855 16.123 16.8405 16.123Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/EditIcon.86f1deba755972679bd9cab0bbbb99f9.svg";
export { ForwardRef as ReactComponent };